import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const trainerEventChannelEnsureResponseSchema = jsonObject
export type TrainerEventChannelEnsureResponse = z.infer<typeof trainerEventChannelEnsureResponseSchema>
